<template>
  <v-container class="fill-height text-center">
    <v-row align="center">
      <v-col cols="12">
        <h1 class="heading font-weight-bold my-5">
          {{ t.app.misericordia }}
          <br />
          <span class="blue--text text--lighten-2">{{ t.app.diadia }}</span>
        </h1>
        <v-btn @click.stop="signInGoogle">
          <v-icon left>account_circle</v-icon>Google
        </v-btn>
        <div class="ma-5 caption">Inicia sesión para comenzar</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "mdd-login",
  computed: {
    t() {
      let t = this.$store.getters["app/trad/activa"];
      let obj = { app: {} };
      obj.app.misericordia = "";
      obj.app.diadia = "";
      return !t ? obj : this.$store.getters["app/trad/activa"];
    }
  },
  methods: {
    signInGoogle() {
      // https://firebase.google.com/docs/auth/web/google-signin
      // this.$fb.auth().signInWithPopup(this.fb.provGoogle)
      this.$fb
        .auth()
        .signInWithRedirect(this.$fb.provGoogle)
        .catch(e => {
          this.$store.dispatch("app/saveErrorReport", {
            e: e,
            line: 38,
            src: "mdd-login"
          });
        });
    }
  }
};
</script>
